import {SocialMediaUrl} from './socialMediaUrl';
import {StringFieldUtil} from '../utils/string-field-util';

export class SocialMedia {

  private _facebook: SocialMediaUrl;
  private _instagram: SocialMediaUrl;
  private _website: SocialMediaUrl;


  constructor() {
    this.facebook = new SocialMediaUrl();
    this.instagram = new SocialMediaUrl();
    this.website = new SocialMediaUrl();
  }

  clone(social: SocialMedia){
    this.facebook.clone(social.facebook);
    this.instagram.clone(social.instagram);
    this.website.clone(social.website);
  }

  fromJson(data: SocialMedia){
    if(data[StringFieldUtil.facebook]) {
      this.facebook = data[StringFieldUtil.facebook];
    }
    if(data[StringFieldUtil.instagram]) {
      this.instagram = data[StringFieldUtil.instagram];
    }
    if(data[StringFieldUtil.website]) {
      this.website = data[StringFieldUtil.website];
    }
  }

  get facebook(): SocialMediaUrl {
    return this._facebook;
  }

  set facebook(value: SocialMediaUrl) {
    this._facebook = value;
  }

  get instagram(): SocialMediaUrl {
    return this._instagram;
  }

  set instagram(value: SocialMediaUrl) {
    this._instagram = value;
  }

  get website(): SocialMediaUrl {
    return this._website;
  }

  set website(value: SocialMediaUrl) {
    this._website = value;
  }

  toMap() {
    return {
      "facebook": this.facebook.toMap(),
      "instagram": this.instagram.toMap(),
      "website": this.website.toMap()
    };
  }

}
